import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Form, Button, Container, Row, Col, Alert, Spinner } from 'react-bootstrap';

const Login = () => {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState(null);
    const [submitting, setSubmitting] = useState(false);
    const { handleLogin } = useAuth();
    const navigate = useNavigate();
    const location = useLocation();

    // Return the user to where they were headed (e.g. /admin) after login.
    const redirectTo = location.state?.from?.pathname || '/';

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError(null);
        setSubmitting(true);
        try {
            await handleLogin(username, password);
            navigate(redirectTo, { replace: true });
        } catch {
            setError('Nie udało się zalogować. Sprawdź nazwę użytkownika i hasło.');
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <Container>
            <Row className="justify-content-md-center">
                <Col md="4" lg="3">
                    <h4 className="text-center mb-4">Logowanie</h4>
                    {error && <Alert variant="danger">{error}</Alert>}
                    <Form onSubmit={handleSubmit}>
                        <Form.Group controlId="formUsername" className="mb-4">
                            <Form.Label>Nazwa użytkownika</Form.Label>
                            <Form.Control
                                type="text"
                                autoComplete="username"
                                value={username}
                                onChange={(e) => setUsername(e.target.value)}
                                required
                                placeholder="nazwa użytkownika"
                            />
                        </Form.Group>
                        <Form.Group controlId="formPassword" className="mb-4">
                            <Form.Label>Hasło</Form.Label>
                            <Form.Control
                                type="password"
                                autoComplete="current-password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                required
                                placeholder="hasło"
                            />
                        </Form.Group>
                        <div className="d-flex justify-content-center mt-3">
                            <Button variant="primary" type="submit" disabled={submitting}>
                                {submitting ? (
                                    <>
                                        <Spinner as="span" size="sm" animation="border" className="me-2" />
                                        Logowanie…
                                    </>
                                ) : (
                                    'Zaloguj'
                                )}
                            </Button>
                        </div>
                    </Form>
                </Col>
            </Row>
        </Container>
    );
};

export default Login;
